import { useQuery } from '@tanstack/react-query';
import { CatalystInsightFilterRequest } from '@toggle/toggle';

import {
  getCatalystInsightDetails,
  getCatalystInsightList,
} from '~/services/insights/catalyst-insights-service';
import { useSubscription } from '~/stores/use-subscription/useSubscription';

export const QUERY_KEY_CATALYST_INSIGHT = 'QUERY_KEY_CATALYST_INSIGHT';

export const useCatalystInsightsList = (
  payload: CatalystInsightFilterRequest,
  isEnabled = true
) => {
  const canShowCompanyCatalysts = !useSubscription(state =>
    state.isBasicOrLightUser()
  );

  return useQuery({
    queryKey: [QUERY_KEY_CATALYST_INSIGHT, payload],
    queryFn: () => getCatalystInsightList(payload),
    select: data =>
      data.filter(
        insight => canShowCompanyCatalysts || insight.category !== 'company'
      ),
    staleTime: 0,
    gcTime: 0,
    enabled: isEnabled,
  });
};

export const QUERY_KEY_CATALYST_INSIGHT_DETAILS =
  'QUERY_KEY_CATALYST_INSIGHT_DETAILS';

export const useCatalystInsightDetails = (
  insightId: string,
  isEnabled = true
) => {
  return useQuery({
    queryKey: [QUERY_KEY_CATALYST_INSIGHT_DETAILS, insightId],
    queryFn: () => getCatalystInsightDetails(insightId),
    staleTime: 0,
    gcTime: 0,
    enabled: isEnabled,
  });
};
